var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAttentionBulb = function SvgAttentionBulb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#AttentionBulb_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.406 0c7.732 0 14 6.268 14 14s-6.268 14-14 14-14-6.268-14-14 6.268-14 14-14Z",
    fill: "#F2F4FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.766 19.14h3.28c.061 0 .11.05.11.11v.438a.437.437 0 0 1-.437.437h-2.625a.437.437 0 0 1-.438-.438v-.437c0-.06.05-.11.11-.11Zm1.64-11.265a4.485 4.485 0 0 1 2.242 8.369v1.584a.437.437 0 0 1-.437.438H12.6a.437.437 0 0 1-.437-.438v-1.584a4.485 4.485 0 0 1 2.242-8.369Zm-1.748 7.517.49.284v1.605h2.516v-1.605l.49-.284a3.5 3.5 0 1 0-3.497 0Z",
    fill: "#5C7AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "AttentionBulb_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.406)",
    d: "M0 0h28v28H0z"
  })))));
};

export default SvgAttentionBulb;